import React from "react";
import { Button } from "@mui/material";
import { LegalDocumentModal, PrivacyPolicy } from "components/LegalDocuments";

type Props = {
  open: boolean;
  handleClose: () => void;
};

export const PrivacyPolicyModal = ({ open, handleClose }: Props) => (
  <LegalDocumentModal
    open={open}
    title="Privacy Policy"
    handleClose={handleClose}
    actions={
      <Button
        onClick={handleClose}
        sx={{
          width: "200px",
          fontSize: "14px",
          bgcolor: "secondary.main",
          color: "common.white",
        }}
      >
        CLOSE
      </Button>
    }
  >
    <PrivacyPolicy defaultExpanded />
  </LegalDocumentModal>
);
